import { render } from "./BorderSelect.vue?vue&type=template&id=e93bbd7a&scoped=true"
import script from "./BorderSelect.vue?vue&type=script&lang=js"
export * from "./BorderSelect.vue?vue&type=script&lang=js"

import "./BorderSelect.vue?vue&type=style&index=0&id=e93bbd7a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e93bbd7a"

export default script